/**
 * ops-core 内で使う JST の固定オフセット。日本は DST が無く年間を通じて UTC+9 固定なので、ISO 時刻を
 * JST の暦（日付境界・曜日）へ写すのはミリ秒シフトで足りる。ops-core の時刻計算（活動ログの表示時刻・
 * オペタンの完了月・営業時間）が同じ値を使うための単一 source（ops-core 内部用。index からは公開しない）。
 * 暦日だけが欲しい場合は `@cortex/jst-calendar` の `getJstYmd`（Intl ベース）を使う。
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business ops-core 内の JST 変換（UTC+9 固定・DST 無し）のオフセットの単一 source
 * @graph-connects none
 */
/** JST は年間を通じて UTC+9 固定（DST 無し）なので、暦の変換はミリ秒シフトで足りる。 @graph-connects none */
export const JST_OFFSET_MS = 9 * 60 * 60 * 1000;
//# sourceMappingURL=jst.js.map